import { render, staticRenderFns } from "./IncidentCard.vue?vue&type=template&id=52d4d04f&scoped=true&"
import script from "./IncidentCard.vue?vue&type=script&lang=ts&"
export * from "./IncidentCard.vue?vue&type=script&lang=ts&"
import style0 from "./IncidentCard.vue?vue&type=style&index=0&id=52d4d04f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d4d04f",
  null
  
)

export default component.exports